module.exports = __webpack_public_path__ + "img/left-arm_active.0a3cbc17.png";